// extracted by mini-css-extract-plugin
export default {"select":"styles_select__ha-Au","desc":"styles_desc__Rsha4"};